import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepContent from '@mui/material/StepContent';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import Typography from '@mui/material/Typography';
import { configs } from './configs';

export default function Instructions() {
  // document.title = `Instructions`;

  return (
    <Box sx={{ width: { sm: '100%' }, margin: 'auto' }}>
      <Typography variant="body1">
        To receive your digital credentials, kindly follow the steps below:
      </Typography>
      <br />
      <Stepper orientation="vertical">
        {configs?.instructions?.map((step: any, index: number) => (
          <Step
            active
            key={`step-instruction${index}`}
            sx={{
              '& .MuiStepIcon-text': {
                fontSize: '1.2rem'
              }
            }}>
            <StepLabel>{step.label}</StepLabel>
            <StepContent>{step.description}</StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
